import React, { useState } from "react";
import { toast } from "react-toastify";
import styles from './workflow-creation2.module.scss'

interface iTag {
    tags: string[];
    addTag: (tag: string) => void;
    removeTag: (tag: string) => void;
    maxTags: number;
    submitTags: any
}

export const TagsFields = ({ tags, addTag, removeTag, maxTags, submitTags }: iTag) => {

    const inputRef = React.useRef<any>(null);
    // track the use input

    const [userInput, setUserInput] = useState<string>("");

    // Handle input onChange

    const handleInputChange = (e: any) => {
        setUserInput(e.target.value);
    };

    // handle Enter key press

    const handleKeyPress = (e: any) => {
        if (e.key === "Enter" || e.type === 'blur') {
            e.preventDefault && e.preventDefault(); // Prevent form submission or new line creation

            // Regex for basic email validation
            const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

            if (userInput.trim() === "") {
                // No input provided
                toast('Please enter an email', {
                    type: 'error',
                    autoClose: 3000,
                    position: "top-center",
                    hideProgressBar: true,
                    theme: "light"
                });
            } else if (!emailRegex.test(userInput)) {
                // Invalid email format
                toast('Enter a valid email', {
                    type: 'error',
                    autoClose: 3000,
                    position: "top-center",
                    hideProgressBar: true,
                    theme: "light"
                });
            } else if (tags.length >= maxTags) {
                // Exceeded max tags
                toast(`You can only add up to ${maxTags} emails`, {
                    type: 'warning',
                    autoClose: 3000,
                    position: "top-center",
                    hideProgressBar: true,
                    theme: "light"
                });
            } else {
                // Valid email and within tag limit
                addTag(userInput);
                setUserInput(""); // Clear the input after adding a tag
                submitTags(userInput)
            }
        }
    };

    const handleBlur = (e: any) => {
        // Call handleKeyPress automatically when input is blurred
        if (userInput.trim()) {
            handleKeyPress({ type: 'blur' }); // Simulating the 'blur' event
        }
    };

    return (
        <div className={styles.emailInputContainer}>
            {tags.map((tag, index) => (
                <span key={index} className={styles.emailTag}>
                    {tag}
                    <button
                        onClick={() => removeTag(tag)}
                        title={`Remove ${tag}`}
                        className={styles.removeTagButton}
                    >
                        &times;
                    </button>
                </span>
            ))}
            <textarea
                name="Recipients"
                placeholder={
                    tags.length === maxTags ?
                        "" :

                        "Enter an email"}
                onKeyDown={handleKeyPress}
                onChange={handleInputChange}
                value={userInput}
                disabled={tags.length === maxTags}
                ref={inputRef}
                onBlur={handleBlur}
                className={styles.emailtextarea}
            />
        </div>
    );
};